var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Slider } from '../form';
export var SliderFilter = function (_a) {
    var _b, _c, _d;
    var filter = _a.filter, filters = _a.filters, setFilters = _a.setFilters;
    var onChange = function (value) {
        var currentValue = value;
        if (currentValue === 0) {
            setFilters(function (prevFilters) { return (__assign(__assign({}, prevFilters), { appliedFilters: __spreadArray([], prevFilters.appliedFilters.filter(function (f) { return f.queryKey !== filter.queryName; }), true) })); });
        }
        else {
            setFilters(function (prevFilters) { return (__assign(__assign({}, prevFilters), { appliedFilters: __spreadArray(__spreadArray([], prevFilters.appliedFilters.filter(function (f) { return f.queryKey !== filter.queryName; }), true), [
                    {
                        queryKey: filter.queryName,
                        value: currentValue,
                        label: "Exp: ".concat(currentValue, " Years"),
                    },
                ], false) })); });
        }
    };
    return (_jsx(Slider, { max: ((_b = filter.options) === null || _b === void 0 ? void 0 : _b.length) ? Math.max.apply(Math, filter.options) : 0, min: ((_c = filter.options) === null || _c === void 0 ? void 0 : _c.length) ? Math.min.apply(Math, filter.options) : 0, onChange: onChange, value: ((_d = filters.appliedFilters.find(function (f) { return f.queryKey === filter.queryName; })) === null || _d === void 0 ? void 0 : _d.value) || 0, marks: filter.options.map(function (option) { return ({
            label: filter.filterType === 'experience' ? "".concat(option, " Years") : "".concat(option),
            value: option,
        }); }), hasInput: true }));
};
